import React from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import ActionItem from './components/ActionItem';

// components

const LastActions = () => {

    const data = [
        {id: 1, status: 'overdue', date: '2026-02-09', title: 'Progetto 1 / 1m5'},
        {id: 2, status: 'to_work', date: '2026-02-21', title: 'Progetto 2 / 2m3'},
        {id: 3, status: 'completed', date: '2026-02-01', title: 'Progetto 3 / 1m8'},
        {id: 4, status: 'overdue', date: '2026-02-08', title: 'Progetto 4 / 3m2'},
        {id: 5, status: 'to_work', date: '2026-02-12', title: 'Progetto 5 / 2m1'},
    ]

    return(
        <OverlayScrollbarsComponent element="div" className="appLastActions" options={{ scrollbars: { autoHide: 'never' } }} defer>
            <ul className="appLastActions__inner">
                {data.map(o => <ActionItem key={o.id} data={o}/>)}
            </ul>
        </OverlayScrollbarsComponent>
    )
}

export default LastActions;